module.exports = __webpack_public_path__ + "img/havannaoak602m_detail_rsh1.857136ee.jpg";